import { Link, useSearchParams } from 'react-router-dom';
import { AlertCircle, CheckCircle2, Clock } from 'lucide-react';

import { useLanguage } from '@/components/LanguageContext';
import { Button } from '@/components/ui/button';

/**
 * `/link-pago?estado=…` — a donde manda `GET /go/pago/<token>/` (Django,
 * `payment_link_redirect`) cuando un enlace de pago de ventas no puede llevar
 * al cliente a Stripe. Pública: quien la ve viene de WhatsApp, normalmente sin
 * sesión.
 *
 * Fuera de `pages/` a propósito: todo lo que vive ahí se auto-monta además
 * como ruta con login.
 */
const ESTADOS = {
  caducado: { Icon: Clock, tone: 'text-amber-500', cta: 'contact' },
  // El código promocional del enlace caducó o se agotó: no se le cobra el
  // precio completo, se le pide otro enlace (`PaymentLinkPromoGone`).
  'promo-caducada': { Icon: Clock, tone: 'text-amber-500', cta: 'contact' },
  invalido: { Icon: AlertCircle, tone: 'text-rose-500', cta: 'contact' },
  'ya-pro': { Icon: CheckCircle2, tone: 'text-emerald-500', cta: 'account' },
  pendiente: { Icon: AlertCircle, tone: 'text-amber-500', cta: 'account' },
  error: { Icon: AlertCircle, tone: 'text-rose-500', cta: 'contact' },
};

export default function PaymentLinkStatus() {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const estado = ESTADOS[params.get('estado')] ? params.get('estado') : 'error';
  const { Icon, tone, cta } = ESTADOS[estado];

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <Icon className={`mx-auto h-12 w-12 ${tone}`} />
        <h1 className="mt-4 text-xl font-semibold text-slate-900">
          {t(`paymentLinkStatus.${estado}.title`)}
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          {t(`paymentLinkStatus.${estado}.body`)}
        </p>
        {cta === 'account' && (
          <Button asChild className="mt-6 bg-[#feae2c] hover:bg-[#f59e0b] text-slate-900">
            <Link to="/settings/billing">{t('paymentLinkStatus.goToAccount')}</Link>
          </Button>
        )}
        {cta === 'contact' && (
          <p className="mt-6 text-sm text-slate-500">{t('paymentLinkStatus.askNewLink')}</p>
        )}
      </div>
    </div>
  );
}
